import { ArrowRight, BrainCircuit } from "lucide-react";
import { Link } from "react-router-dom";
import { ParticleField } from "../components/site/ParticleField";
import { MagneticButton } from "../components/site/MagneticButton";
import { Reveal } from "../components/site/Reveal";
import { useCalendly } from "../components/site/CalendlyModal";

export const FinalCTA = () => {
  const { openCalendly } = useCalendly();
  return (
    <section className="relative py-32 md:py-44 overflow-hidden grain" data-testid="final-cta">
      <ParticleField density={0.7} />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[680px] h-[420px] rounded-full bg-[var(--green)]/10 blur-[150px]" aria-hidden="true" />
      <div className="absolute left-[15%] bottom-0 w-[380px] h-[300px] rounded-full bg-[var(--blue)]/10 blur-[130px]" aria-hidden="true" />
      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
        <Reveal>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight">
            ¿Qué podríamos <span className="text-gradient">transformar</span> en tu empresa?
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-7 max-w-xl text-base md:text-lg text-[var(--muted)] leading-relaxed">
            Cuéntanos qué proceso, aplicación o reto tecnológico quieres mejorar.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link to="/#motor-ia" data-testid="final-cta-ai">
              <MagneticButton testId="final-cta-ai-button">
                <BrainCircuit size={16} className="text-[var(--green)]" /> Analizar mi proceso con IA
              </MagneticButton>
            </Link>
            <MagneticButton variant="ghost" onClick={openCalendly} testId="final-cta-agendar">
              Agendar una reunión <ArrowRight size={15} className="text-[var(--cyan)]" />
            </MagneticButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
